@for (inquiry of extraRequirementsInquiries; track inquiry; let i = $index) {
  <div class="layout__inner-card flex flex-column gap-3">
    <strong i18n>Commande #{{ i + 1 }}</strong>
    <p class="margin--none"
      ><strong i18n>Exigences :</strong> {{ translateExtraRequirements(inquiry.requirements) }}</p
    >
    <p class="margin--none"
      ><strong i18n>Détails supplémentaires :</strong> <span [innerHTML]="inquiry.note | emMarkdown"></span
    ></p>
    <div class="text-right text-sm text-600 pt-2" i18n> Le {{ inquiry.createdAt | date: dateFormat }} </div>
  </div>
}
